import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/jf-logo.png';
//import Flag from 'react-world-flags';
import ina from '../images/indonesia.png';
import eng from '../images/england.png';



function NavbarTop(){
    const [isOpen, setIsOpen] = useState(false);
    const languages = [
        { code: 'id', name: 'Indonesia', country: 'IDN' },
        { code: 'en', name: 'English', country: 'GB_ENG' },
    ];

    const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

    const handleLanguageChange = (e) => {
        const languageCode = e;
        const language = languages.find((lang) => lang.code === languageCode);
        localStorage.setItem('lang_code', languageCode);
        localStorage.setItem('lang_country', language.country);
        setSelectedLanguage(language);
        window.location.reload();
    };


    const getLang    = localStorage.getItem('lang_code');
    const getCountry = localStorage.getItem('lang_country');

    return (<nav class="flex justify-between text-white w-screen" style={{ backgroundColor: '#fd9400' }}>
    <div class="px-5 xl:px-12 py-2 flex w-full items-center">
        <div class="hidden md:flex px-2 mx-auto font-semibold font-heading space-x-12">
            <img src={Logo} alt="logo" className="max-w-xs" style={{ height: 80, color: '#fff', justifyContent: 'center', alignItems: 'center', display: 'flex' }} />
        </div>
            {/*<select
                className="mb-0 p-0 border border-gray-300 rounded"
                value={getLang ? getLang  : selectedLanguage.code}
                onChange={handleLanguageChange}
                style={{ color: 'red' }}
            >
                {languages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                        <img src={Logo} />
                    </option>
                ))}
            </select>*/}

            {/* Hamburger Icon (visible on mobile) */}
          <div className="block sm:hidden rounded" style={{ backgroundColor : '#fd9400' }}>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
          {!isOpen &&
          <div class="w-[250px] sm:hidden"></div>
          }

            {!isOpen && languages.map((lang) => {
                return (
                    <div key={lang.code} class="ml-1s">
                        <button
                            className="flex items-center space-x-1 px-1 py-1 text-sm cursor-pointer"
                            onClick={() => handleLanguageChange(lang.code)} // used to change language that needs to be rendered
                            disabled={getLang === lang.code}
                        >
                            {/*<Flag code={lang.country} className="w-8 h-8 rounded-full" style={{ opacity: getLang != lang.code ?  0.5 : ''  }} />*/}
                            {/*<span>{lang.name}</span>*/}
                            { lang.code === 'id' ?
                            <img src={ina} style={{ opacity: getLang !== lang.code ?  0.5 : ''  }} alt="" />
                            :
                            <img src={eng} style={{ opacity: getLang !== lang.code ?  0.5 : ''  }} alt="" />
                            }
                        </button>
                    </div>
                );
            })}

            {/* Mobile Menu (visible when toggled) */}
          {isOpen && (
            <div className="sm:hidden lg:flex lg:items-left lg:w-auto w-full" style={{ color: '#fff', fontFamily: 'MuseoSansRounded900' }}>
             <ul class="text-left items-left gap-x-2 pt-0 md:gap-x-4 lg:flex lg:pt-0" style={{ listStyleType: 'none'  }}>
                  <li class="py-0 lg:py-0"><Link className="block px-4 py-2" to="/home">{getLang === 'id' ? 'BERANDA' : 'HOME'}</Link></li>
                  <li class="py-0 lg:py-0"><Link className="block px-4 py-2" to="/allproduct">{getLang === 'id' ? 'PRODUK' : 'PRODUCTS'}</Link></li>
                  <li class="py-0 lg:py-0"><Link className="block px-4 py-2" to="/wheretobuy">{getLang === 'id' ? 'BELI DI SINI' : 'WHERE TO BUY'}</Link></li>
                  <li class="py-0 lg:py-0"><Link className="block px-4 py-2" to="/blog">{getLang === 'id' ? 'BERITA & INFO' : 'BLOG & EVENT'}</Link></li>
              </ul>
            </div>
          )}
    </div>
</nav>);
}

export default NavbarTop;